import { useState } from 'react';
import { DragEndEvent } from '@dnd-kit/core';

export default function useReordering<T extends { id?: string }>() {
  const [isReordering, setIsReordering] = useState(false);

  const onDragEnd = (
    e: DragEndEvent,
    fieldsValue: T[],
    fieldsMove: (oldIndex: number, newIndex: number) => void,
  ) => {
    const { active, over } = e;

    if (active.id === over.id) return;

    const oldIndex = fieldsValue.findIndex(({ id }) => id === active.id);
    const newIndex = fieldsValue.findIndex(({ id }) => id === over.id);

    fieldsMove(oldIndex, newIndex);
    setIsReordering(false);
  };

  return { isReordering, setIsReordering, onDragEnd };
}
